var exports = {
  "Sr": "Pagination.module__paginationBar___LTU2LX",
  "_s": "Pagination.module__paginationWrapper___LTU2LX",
  "gc": "Pagination.module__pageButton___LTU2LX",
  "Ks": "Pagination.module__pageButtonActive___LTU2LX",
  "oq": "Pagination.module__ellipsisButton___LTU2LX",
  "kh": "Pagination.module__pageInputForm___LTU2LX",
  "aW": "Pagination.module__pageInputLabel___LTU2LX",
  "AU": "Pagination.module__pageInput___LTU2LX",
  "Mp": "Pagination.module__focusRingCircular___LTU2LX",
};

module.exports = exports;
